// extracted by mini-css-extract-plugin
export default {"container":"AccountAlert_container__XR2n6","title":"AccountAlert_title__ShSqj","detail":"AccountAlert_detail__IKy0w","done":"AccountAlert_done__Nl7xY"};